import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-paper" data-id="element-0" data-mp="28u5xmlt5v3cb">
      <MetaPixel data-id="element-1" data-mp="28t4lsf4bmctj" />
      <CountdownBar data-id="element-2" data-mp="28sl48zil1qg1" />
      <main data-id="element-3" data-mp="28s2ynca15zvg">
        <Hero data-id="element-4" data-mp="23vkw8j26adma" />
        <StatsBar data-id="element-5" data-mp="23vul23bheeqe" />
        <Difference data-id="element-6" data-mp="23u9qidp62vsj" />
        <Recognize data-id="element-7" data-mp="23v2s7099qv3t" />
        <WhatsInside data-id="element-8" data-mp="23ti7e2craqj5" />
        <InstantAccess data-id="element-9" data-mp="3ik7k0rkruvvx" />
        <Bonuses data-id="element-10" data-mp="3iiwf2oflbi38" />
        <Offer data-id="element-11" data-mp="3ijfv1zlojwem" />
        <Guarantee data-id="element-12" data-mp="3ihv2gfixenje" />
        <Testimonials data-id="element-13" data-mp="3mlj8gtrwtb2j" />
        <Faq data-id="element-14" data-mp="3ml17jjuay8oa" />
        <FinalCta data-id="element-15" data-mp="3mkhmvvd9p66k" />
      </main>
      <Footer data-id="element-16" data-mp="3mjpyb4i388ps" />
    </div>;
}